<div #selectSearch [style.width.px]="computedWidth" [ngClass]="selectClass" class="select-search">
  <span>{{ '' + selectedText(selected) | translate }}</span>
  <mat-icon>{{ dropdownIcon() }}</mat-icon>
</div>
<div
  class="dropdown-content"
  [style.width]="dropdownWidth"
  [style.min-width.px]="computedWidth"
  [ngClass]="selectClass"
  [hidden]="!isSelecting"
  (click)="$event.stopPropagation()"
  >
  @if (showSearch) {
    <va-search-box (update)="searchTerm = $event" />
  }
  <ul>
    @for (option of filteredOptions(searchTerm); track option) {
      <li (click)="optionClicked(option, $event)">
        {{ '' + optionText(option) | translate }}
      </li>
    }
  </ul>
</div>
